// How a grid that still holds rows shows that new rows are on the way. 'linear-progress' keeps
// the old rows, dimmed, under a bar at the top. 'skeleton' swaps them for grey placeholder rows.
export const LOADING_VARIANT: 'linear-progress' | 'skeleton' = 'linear-progress'

// A grid with no rows keeps MUI's own loading overlay.
export const gridLoadingSlotProps = (hasRows: boolean) =>
  hasRows ? { loadingOverlay: { variant: LOADING_VARIANT } } : undefined

// The old rows stay under the bar, dimmed.
export const gridLoadingDimSx = (loading: boolean, hasRows: boolean) =>
  loading && hasRows && LOADING_VARIANT === 'linear-progress'
    ? { '& .MuiDataGrid-row': { opacity: 0.45 } }
    : {}

// For the shared grid, whose own style pins the overlay over the whole grid: the bar starts
// below the sticky header, which covers the top of the overlay.
export const gridLoadingSx = (loading: boolean, hasRows: boolean) =>
  loading && hasRows
    ? {
        '& .MuiDataGrid-virtualScroller .MuiDataGrid-overlayWrapper.MuiDataGrid-overlayWrapper':
          {
            top: 'var(--DataGrid-topContainerHeight, 0px) !important',
            height:
              'calc(100% - var(--DataGrid-topContainerHeight, 0px)) !important',
            alignItems: 'flex-start !important',
          },
        '& .MuiDataGrid-virtualScroller .MuiDataGrid-overlayWrapperInner': {
          alignItems: 'flex-start !important',
        },
        ...gridLoadingDimSx(loading, hasRows),
      }
    : {}
